export const hasValue = (value: unknown): boolean => {
	if (value === null || value === undefined) return false;
	if (typeof value === 'string') return value.trim().length > 0;
	if (typeof value === 'number') return !isNaN(value);
	if (typeof value === 'boolean') return true;
	if (Array.isArray(value)) return value.some(hasValue);
	if (typeof value === 'object') {
		return 'id' in value ? hasValue((value as { id: unknown }).id) : false;
	}
	return false;
};
